"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridBoxId = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const useDisableScroll_1 = require("../../helpers/useDisableScroll");
const features_1 = require("../features");
const Wrapper = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    position: relative;

    ${(props) => props.isEmpty &&
    (0, styled_components_1.css) `
            height: 100%;
            overflow: auto;
        `}

    ${(props) => props.disabled &&
    (0, styled_components_1.css) `
            pointer-events: none;
        `}
`;
exports.gridBoxId = 'grid-box';
const DisabledOverlay = styled_components_1.default.div `
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: transparent;
    z-index: 9999;
`;
const GridBox = (0, react_1.forwardRef)(({ children, disabled }, ref) => {
    const { state: { isEmpty } } = (0, features_1.useGridContext)();
    const innerRef = (0, react_1.useRef)(null);
    ref = ref || innerRef;
    (0, useDisableScroll_1.useDisableScroll)({
        activate: disabled,
        ref
    });
    return (react_1.default.createElement(Wrapper, { ref: ref, "data-selector-id": exports.gridBoxId, isEmpty: isEmpty, disabled: disabled },
        children,
        disabled && react_1.default.createElement(DisabledOverlay, null)));
});
exports.default = GridBox;
//# sourceMappingURL=GridBox.js.map